import React from "react";
import { Radio, Table, TableProps } from "antd";
import styles from "./index.module.less";
import { EvaluationDataType } from "../../type";
import { useTranslation } from "react-i18next";

type Props = {
  evaluationData?: EvaluationDataType[];
  onScoreChange?: (indicatorId: number, score: number) => void;
};

export const PerformanceEvaluationCard: React.FC<Props> = ({
  evaluationData,
  onScoreChange,
}) => {
  const { t } = useTranslation("supplierPerformance");

  const columns: TableProps<EvaluationDataType>["columns"] = [
    {
      title: t("考核维度"),
      dataIndex: "dimensionName",
      key: "dimensionName",
      width: 120,
      align: "center",
      onCell: (_, index) => {
        if (index === 0) return { rowSpan: 3 };
        if (index === 1 || index === 2) return { rowSpan: 0 };
        if (index === 3) return { rowSpan: 2 };
        if (index === 4) return { rowSpan: 0 };
        return {};
      },
      render: (text) => (
        <div style={{ fontWeight: "bold", fontSize: "18px" }}>{text}</div>
      ),
    },
    {
      title: t("考核项"),
      dataIndex: "indicator2Name",
      key: "indicator2Name",
      width: 120,
      align: "center",
      render: (text) => <div style={{ fontWeight: "500" }}>{text}</div>,
    },
    {
      title: <span style={{ color: "#ef4444" }}>{t("差 (25分)")}</span>,
      dataIndex: "level1Remarks",
      key: "level1Remarks",
      align: "center",
      render: (text, record) => (
        <div
          style={{ padding: "8px 0", cursor: "pointer" }}
          onClick={() => onScoreChange?.(record.indicatorId, 25)}
        >
          <Radio
            checked={record.score === 25}
            style={{ marginBottom: "8px" }}
          />
          <div style={{ fontSize: "14px", color: "#6b7280", padding: "0 8px" }}>
            {text}
          </div>
        </div>
      ),
    },
    {
      title: <span style={{ color: "#fb923c" }}>{t("一般 (50分)")}</span>,
      dataIndex: "level2Remarks",
      key: "level2Remarks",
      align: "center",
      render: (text, record) => (
        <div
          style={{ padding: "8px 0", cursor: "pointer" }}
          onClick={() => onScoreChange?.(record.indicatorId, 50)}
        >
          <Radio
            checked={record.score === 50}
            style={{ marginBottom: "8px" }}
          />
          <div style={{ fontSize: "14px", color: "#6b7280", padding: "0 8px" }}>
            {text}
          </div>
        </div>
      ),
    },
    {
      title: <span style={{ color: "#3b82f6" }}>{t("良好 (75分)")}</span>,
      dataIndex: "level3Remarks",
      key: "level3Remarks",
      align: "center",
      render: (text, record) => (
        <div
          style={{ padding: "8px 0", cursor: "pointer" }}
          onClick={() => onScoreChange?.(record.indicatorId, 75)}
        >
          <Radio
            checked={record.score === 75}
            style={{ marginBottom: "8px" }}
          />
          <div style={{ fontSize: "14px", color: "#6b7280", padding: "0 8px" }}>
            {text}
          </div>
        </div>
      ),
    },
    {
      title: <span style={{ color: "#16a34a" }}>{t("优秀 (100分)")}</span>,
      dataIndex: "level4Remarks",
      key: "level4Remarks",
      align: "center",
      render: (text, record) => (
        <div
          style={{ padding: "8px 0", cursor: "pointer" }}
          onClick={() => onScoreChange?.(record.indicatorId, 100)}
        >
          <Radio
            checked={record.score === 100}
            style={{ marginBottom: "8px" }}
          />
          <div style={{ fontSize: "14px", color: "#6b7280", padding: "0 8px" }}>
            {text}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.card}>
      <Table
        columns={columns}
        dataSource={evaluationData}
        pagination={false}
        bordered
        size="middle"
      />
    </div>
  );
};
